import React from 'react';
import { View, Text, StyleSheet, FlatList, TouchableOpacity, Platform } from 'react-native';
import LoadingIndicator from '../../../../components/ActivityIndicator';
import { MainColors } from '../../../../constants/Colors';
import FontSizes from '../../../../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import TwoLineMessage from '../../../../components/TwoLineMessage';
import useInfiniteScroll from '../../../../utils/useInfiniteScroll';
import useFetch from '../../../../utils/useFetch';

const OrganizationsList = (props) => {
    const { get } = useFetch();
    const pageSize = 50;

    const getOrganizations = async (pageNumber) => await get(`/api/organizations?page=${pageNumber}&count=${pageSize}`);

    const [organizationsList, onScrollPage, onRefresh, isRefreshing] = useInfiniteScroll(getOrganizations);

    return (
        <View style={styles.container}>
            <LoadingIndicator isLoading={isRefreshing}>
                {organizationsList && organizationsList.length > 0 ? (
                    <FlatList
                        style={styles.listContainer}
                        data={organizationsList}
                        keyExtractor={(item) => item.organizationId.toString()}
                        ListFooterComponent={props.ListFooterComponent}
                        ListFooterComponentStyle={{ marginVertical: 30 }}
                        onEndReached={onScrollPage}
                        onEndReachedThreshold={5}
                        onRefresh={onRefresh}
                        refreshing={isRefreshing}
                        renderItem={({ item }) => (
                            <View style={styles.listItemContainer}>
                                <Text style={styles.organizationName}>{item.organizationName}</Text>
                                <TouchableOpacity style={styles.editButton}
                                    onPress={() => props.onEditButtonPress(item.organizationId)}>
                                    <MaterialCommunityIcons name="square-edit-outline" size={24}
                                        color={MainColors.primary} />
                                </TouchableOpacity>
                            </View>
                        )}
                    />
                ) : (
                        <TwoLineMessage
                            firstLine={props.noOrgsMessageLineOne}
                            secondLine={props.noOrgsMessageLineTwo}
                            createMode={true}
                            onButtonPress={props.onEmptyOrgsListCreateBtnPress}
                            buttonText='Create Organization'
                            buttonAccessibilityLabel='Create new organization'
                            accessibilityHint='Press this button to create a new organization'
                        />
                    )
                }
            </LoadingIndicator>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center'
    },
    textContainer: {
        marginVertical: 30,
        alignItems: 'center'
    },
    emptyOrgsTextOne: {
        fontSize: FontSizes.medium,
        fontWeight: '700',
        color: MainColors.darkGray,
        paddingBottom: 8
    },
    emptyOrgsTextTwo: {
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        flexWrap: 'wrap',
        marginHorizontal: 20,
        textAlign: 'center'
    },
    listContainer: {
        padding: 20,
        width: '100%'
    },
    listItemContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: 10,
        paddingBottom: 5,
        borderBottomWidth: Platform.OS === 'web' ? 1 : 0,
        borderBottomColor: Platform.OS === 'web' ? MainColors.faintGray : null,
    },
    organizationName: {
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        fontWeight: '500',
        letterSpacing: 0.8,
        flex: 1,
        flexWrap: 'wrap',
    },
    editButton: {
        alignSelf: 'flex-start',
        paddingLeft: 8
    }
});

export default OrganizationsList;